import { useQuery } from '@tanstack/react-query';

import { API_QUERY_KEYS } from 'consts';
import { useGetCurrentBoardId, useGetCurrentOrganisationId } from 'hooks';

import { getFormsOptions } from '../requests';

export const useGetFormsOptions = () => {
  const organisationId = useGetCurrentOrganisationId();
  const boardId = useGetCurrentBoardId() as number;

  return useQuery({
    queryKey: [API_QUERY_KEYS.formsOptions],
    queryFn: () => getFormsOptions({ pathParams: { organisationId, boardId } }),
  });
};
